import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expandable-section',
  templateUrl: './expandable-section.component.html',
  styleUrls: ['./expandable-section.component.css'],
  animations: [
    trigger('halfTurn', [
      state('open', style({
        transform: 'rotate(0deg)'
      })),
      state('closed', style({
        transform: 'rotate(-90deg)'
      })),
      transition('closed <=> open', [
        animate('0.2s')
      ]),
    ]),
    trigger('expand', [
      state('full', style({
        height: '*'
      })),
      state('collapsed', style({height: '0px', minHeight: '0'})),
      transition('full <=> collapsed', animate('0.2s cubic-bezier(.35,.67,.4,.7)')),
    ]),
  ],
})
export class ExpandableSectionComponent implements OnInit {
  expanded = false;
  animationInProgress = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleTextExpansion() {
    if (this.animationInProgress) {
      return;
    }
    this.animationInProgress = true;
    this.expanded = !this.expanded;
  }
}
